import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { fetchExerciseDetailsByKey } from "sj-ui-toolkit/src/api";
import { FullScreenLoader } from "sj-ui-toolkit/src/components";
import type { VideoLessonDetails } from "../Lesson/VideoLesson/VideoProvider";

import { useLessonLoader } from "../../hooks/useLessonLoader";
import VideoLesson from "../Lesson/VideoLesson";

import type { ExerciseContentInput, LessonDetails } from "../../hooks/useLessonLoader";

export default function ExercisePage() {
  // Enable flex layout for this page
  const { "*": contentKey } = useParams();
  const [exerciseContent, setExerciseContent] = useState<ExerciseContentInput | null>(null);
  const navigate = useNavigate();
  const { lessonDetails } = useLessonLoader({ exerciseContent });

  const onLessonFinish = () => {
    navigate("/");
  };

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        const data = await fetchExerciseDetailsByKey(contentKey!);
        setExerciseContent(data as ExerciseContentInput);
      } catch (error) {
        console.error("Error fetching exercise details:", error);
      }
    };

    fetchExercise();
  }, []);

  if (!exerciseContent || !lessonDetails) {
    return (
      <div className="h-full">
        <FullScreenLoader />
      </div>
    );
  }

  return (
    <VideoLesson
      lessonDetails={lessonDetails as LessonDetails as VideoLessonDetails}
      onLessonFinish={onLessonFinish}
      exerciseOnly={true}
    />
  );
}
